/* eslint-disable no-use-before-define */
import React from 'react'
import { hideModal, fmt } from '../twd/twd'

export default ({list=[]} = {}) => {

    return <React.Fragment>
    <div className="modal-dialog modal-sm">
    <div className="modal-content">
        <div className="modal-header">
            <button
                data-name="bond-detail-underwriter-close"
                className="close"
                aria-label="close"
                type="button"
                onClick={hideModal}>
            <i className="material-icons" aria-hidden="true">close</i>
            </button>

            <h3 className="modal-title text-center vertical-offset-sm">Factor schedule</h3>
            <div className="row form-group subhead">
            <div className="col-xs-12 col-md-12">

            <div className="table-responsive">
            <table
                data-name='bond-detail-underwriter-table'
                className="table align-top table-striped">
            <thead>
                <tr>
                <th>Date</th>
                <th className="text-right">Factor</th>
                </tr>
            </thead>
            <tbody>{
                list.map((r,i)=> {
                    return <tr key={i}>
                        <td>{fmt.mdy(r.factorDt)}</td>
                        <td className="text-right">{fmt.factor(r.factor)}</td>
                    </tr>
                })
            }</tbody>
            </table>
            </div>

            </div>
            </div>
        </div>

    </div>
    </div>
    </React.Fragment>
}
